import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Button,
  MenuItem,
  Select,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { updateFieldCrop } from '../../lib/api';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { actions } from '../../store/dux/yield-dux';
import { DialogTitle } from '../../components/DialogTitle';
import { useAlerts } from '../../hooks/use-alerts';
import { useContext } from './context.jsx';

export default function YieldUpdateCropDialog(props) {
  const { selectedRawFields, onClose } = props;
  const crop = selectedRawFields[0]?.harvestedCrop || '';
  const growerId = useSelector(growerSelectors.selectedId) || '';
  const { year } = useContext();
  const [newCrop, setNewCrop] = useState(crop);
  const [savingCrop, setSavingCrop] = useState(false);
  const dispatch = useDispatch();
  const { showError } = useAlerts();

  async function saveCrop() {
    setSavingCrop(true);

    updateFieldCrop(growerId, year, newCrop, selectedRawFields)
      .then(() => {
        onClose();
        dispatch(actions.loadYieldData(growerId, year));
      })
      .catch((error) => {
        showError(error);
      })
      .finally(() => {
        setSavingCrop(false);
      });
  }

  function cancelEdit() {
    setNewCrop(crop);
    onClose();
  }

  return (
    <Dialog keepMounted open maxWidth="sm" fullWidth>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.primary.main,
          height: 10,
        }}
      ></Box>
      <DialogTitle onClose={cancelEdit} title={'Update Harvested Crop Type'} />
      <DialogContent>
        <Select
          sx={{
            minWidth: 410,
            mt: 3,
            mb: 2,
          }}
          value={newCrop}
          onChange={(e) => setNewCrop(e.target.value)}
          data-testid={'select-crop'}
        >
          <MenuItem value="corn">Corn</MenuItem>
          <MenuItem value="soy">Soy</MenuItem>
          <MenuItem value="wheat">Wheat</MenuItem>
        </Select>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={cancelEdit}
          data-testid={'cancel-edit'}
          variant="contained"
          color="dark"
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={saveCrop}
          loading={savingCrop}
          data-testid={'save-crop'}
          variant="contained"
          color="primary"
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
